import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { SelectComponent, SelectOption, SessionPreferenceService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { ProductStatisticComponent } from './productstatistic/productstatistic.component';
import { PartnerStatisticComponent } from './partnerstatistic/partnerstatistic.component';
import { FestivalStatisticComponent } from './festivalstatistic/festivalstatistic.component';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-statistics',
	templateUrl: './statistics.component.html',
	styleUrls: ['./statistics.component.scss'],
	standalone: true,
	imports: [SelectComponent, TranslationPipe, ProductStatisticComponent, PartnerStatisticComponent, FestivalStatisticComponent]
})
export class StatisticsComponent implements OnInit {
	private _sessionPreference = inject(SessionPreferenceService);
	private _translationService = inject(TranslationService);

	readonly selectedView = signal<string>('productView');
	readonly viewOptions = signal<SelectOption[]>([]);

	ngOnInit(): void {
		this.viewOptions.set([
			{ id: 'productView', name: this._translationService.translate('admin.product.statistics.field.productView') },
			{ id: 'partnerView', name: this._translationService.translate('admin.product.statistics.field.partnerView') },
			{ id: 'festivalView', name: this._translationService.translate('admin.product.statistics.field.festivalView') }
		]);

		const saved = this._sessionPreference.load<string>('statistics-view-selection');
		if (saved) {
			this.selectedView.set(saved);
		}
	}

	onChangeView(newValue: string | number | null): void {
		if (newValue === null) return;
		this.selectedView.set(String(newValue));
		this._sessionPreference.save('statistics-view-selection', String(newValue));
	}
}
